import {createAction, ActionsUnion} from '@pwbapps/reduxcore';

export const DATA_NORMALIZED = 'DATA_NORMALIZED';

export const Actions = {
    dataNormalized: ({feature}: {feature: string}) => createAction(DATA_NORMALIZED, {}, feature)
}

export type Actions = ActionsUnion<typeof Actions>